import { combineEpicsIsolated } from 'utils/epicRegistry'

import atoOverviewEpics from './AtoOverview/epics'
import awarenessEpics from './Awareness/epics'
import homeEpics from './Home/epics'
import threatProtectionEpics from './ThreatProtection/epics'
import visualDetectionEpics from './VisualDetection/epics'

export default combineEpicsIsolated(
  homeEpics,
  awarenessEpics,
  visualDetectionEpics,
  threatProtectionEpics,
  atoOverviewEpics
)
